import React from 'react';
import { CloudPremisePlugin } from "@cloudpremise/portal_core";
import { routes, menus, userMenus, footerMenus, settingMenus } from "./src";
import packageJson from "./package.json";
import Config from "../../Config";
import MsalProvider from "./src/components/MsalProvider";

class Auth extends CloudPremisePlugin {};

const AuthPlugin = new Auth ({
    name: packageJson.name,
    description: packageJson.description,
    status: packageJson.status,
    routes: routes,
    menus: menus,
    userMenus: userMenus,
    footerMenus: footerMenus,
    settingMenus: settingMenus,
    render: () => {
        return null
    },
    onConfig(plugin: CloudPremisePlugin) {
        try{
            let config = JSON.parse(decodeURIComponent(plugin.Configuration__c));
            if(typeof(config) === "object" && config.hasOwnProperty("auth") && config.auth.hasOwnProperty("microsoft")){
                const msConfig = config.auth.microsoft;
                Config['REACT_APP_MS_CLIENT_ID'] = msConfig.clientId;
                Config['REACT_APP_MS_AUTHORITY_URL'] = msConfig.authorityUrl;
            }
            if(typeof(config) === "object"){
                this.config = config;
            }

            if(typeof(config) === "object" && config.hasOwnProperty("auth") && config.auth.hasOwnProperty("google")){
                const googleConfig = config.auth.google;
                Config['REACT_APP_GOOGLE_CLIENT_ID'] = googleConfig.clientId;
            }
            if(typeof(config) === "object" && config.hasOwnProperty("auth") && config.auth.hasOwnProperty("github")){
                const githubConfig = config.auth.github;
                Config['REACT_APP_GITHUB_CLIENT_ID'] = githubConfig.clientId;
            }
            if(typeof(config) === "object" && config.hasOwnProperty("auth") && config.auth.hasOwnProperty("facebook")){
                const facebookConfig = config.auth.facebook;
                Config['REACT_APP_FACEBOOK_APP_ID'] = facebookConfig.appId;
            }
        }catch(e){ console.log(e); }
    },
    getProviders() {
        const msalConfig = Config.getMsalConfig();
        const providers = [];
        providers.push({
            Provider: MsalProvider,
            props: {key: "microsoft", clientId: msalConfig.auth.clientId}
        });
        return providers;
    }
});

export default AuthPlugin;